import { getApiBaseUrl } from '../auth/apiBaseUrl';

/** Public endpoint — uses fetch so login flow is not affected by axios 401 handling. */
export const getIpInfo = async () => {
  try {
    const response = await fetch(`${getApiBaseUrl()}/User/ip-address`, {
      credentials: 'include',
    });
    if (!response.ok) {
      return { ipAddress: 'Unknown', userAgent: navigator.userAgent };
    }
    return response.json();
  } catch {
    return { ipAddress: 'Unknown', userAgent: navigator.userAgent };
  }
};
